
<template>
  <v-container>
    <v-data-table v-if="all_executions" mobile-breakpoint="900" :items="all_executions" :headers="execution_list_header" :loading="loading" :search="search">
      <template v-slot:top>
        <v-row align="center" justify="space-between" class="px-3">
          <v-col cols="12" md="6">
            <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Encontrar"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-center">
            <v-btn small color="primary" :to="{name: 'CreateExecution'}"><v-icon left>mdi-plus</v-icon>medição</v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.date="{ item }">
        {{ $dayjs(item.date).format('DD/MM/YYYY') }}    
      </template>
      <template v-slot:item.actions="{ item }">
        <div v-if="item.id">
          <v-btn :to="{name: 'ShowExecution', params: {id: item.id}}" color="primary" dark small>realizar</v-btn>
        </div>
      </template>
      <template v-slot:no-data>
        Não há dados
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ExecutionList',
  data() {
    return {
      search: '',
      loading: false,
      execution_list_header: [
        { text: 'Id', value: 'id' },
        { text: 'Nome', value: 'name' },
        { text: 'Departamento', value: 'department_name' },
        { text: 'Data', value: 'date' },
        { text: 'Ações', value: 'actions' }
      ]
    }
  },
  mounted () {
    this.getExecutions();
  },
  methods: {
    getExecutions() {
      this.loading = true;
      this.indexExecutions({is_done: 0, role: this.user.role.name}).then(() => {
        this.loading = false;
      });
    },
    ...mapActions({
      indexExecutions: 'Execution/index'
    })
  },
  computed: {
    ...mapState({
      all_executions: state => state.Execution.all_executions,
      user: state => state.User.user
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>